import { SESSION_STORAGE_APP_STATE_KEY } from 'config/consts';
import { windowUtils } from './window';
import { AppState } from 'stores/appStore';
import { CategoryKey } from 'config/categories';
import { productsByCategory } from 'config/products';

const setAppState = (state: AppState) => {
  windowUtils.getSafeWindow()?.sessionStorage.setItem(SESSION_STORAGE_APP_STATE_KEY, JSON.stringify(state));
};

const getInitialAppState = (): AppState => {
  const window = windowUtils.getSafeWindow();
  const appStateString = window?.sessionStorage.getItem(SESSION_STORAGE_APP_STATE_KEY);
  const selectedCategory = CategoryKey.BestSellers;
  const [firstProduct] = productsByCategory[selectedCategory];

  const defaultState: Omit<AppState, 'metaSiteId'> = {
    selectedProducts: [firstProduct.id],
    currentStep: undefined,
    localFile: undefined,
    storeName: undefined,
    mediaUrl: undefined,
    siteUrl: undefined,
    selectedCategory,
    mockups: [],
  };

  const storedState: AppState = appStateString ? JSON.parse(appStateString) : {};

  return {
    ...defaultState,
    ...(storedState.metaSiteId === window?.__META_SITE_ID__ ? storedState : {}),
    metaSiteId: window?.__META_SITE_ID__,
  };
};

export const sessionStorageUtils = {
  setAppState,
  getInitialAppState,
};
